var React = require('react');

function Electric (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.242 5.14812V10.4101L14.1301 9.90425L15.062 9.6545L12.4763 17.855L11.5336 15.0834L11.0813 13.754L9.72534 14.1174L8.02734 14.5723V6.32488L12.242 5.14812ZM13.742 3.17188L6.52734 5.18638V16.5271L10.1135 15.5664L12.5303 22.6719L17.3142 7.49788L13.7412 8.45525V3.17188H13.742Z","fill":"currentColor"}));
}

Electric.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Electric;

Electric.default = Electric;
